import emptySliceApi from '../../shared/store/emptyApiSlice';
import { ConsentQueryResult } from './models';

interface ConsentFlag {
  flag: boolean;
}

interface ConsentApiRequest {
  body: ConsentFlag;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getConsentDetails: builder.query<ConsentQueryResult, void>({
      query: () => `v4/users/consent`,
      providesTags: ['HubUserConsentData'],
    }),
    updateConsent: builder.mutation<ConsentFlag, ConsentApiRequest>({
      query: ({ body }) => ({
        url: `v4/users/consent`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['HubUserConsentData', 'AccountData'],
    }),
  }),
});

export const { useGetConsentDetailsQuery, useUpdateConsentMutation } = apiSlice;
